import React from 'react'
import './AllItemsComponent.css'
const AllItemsComponent = () => {
  return (
    <div className="banner_section" style={{ flex: "1" }}>
      AllItemsComponent
    </div>
  )
}

export default AllItemsComponent
